<template>
    <div class="dTBodyRow" @click="showLogDetailsPanel(logItem)">
        <div class="dCell" :class="logItem.index === selectedIncomingMsgItem.index && logDetailsPanel ? 'active' : ''">
            <strong>{{logItem.index}}</strong>
        </div>
        <div class="dCell" :class="logItem.index === selectedIncomingMsgItem.index && logDetailsPanel ? 'active' : ''">
            <strong>{{logItem.LogID}}</strong>
        </div>
        <div class="dCell" :class="logItem.index === selectedIncomingMsgItem.index && logDetailsPanel ? 'active' : ''">
            <!-- <strong>{{logItem.IntegrationName}}</strong> -->
            <span class="integrationCard" >
                <span class="ApiCard ApiCardHeightAdjustment" :class="logItem.IntegrationName">
                    <span class="integrationLogo integrationLogoAlignment"></span>
                </span>
            </span>
        </div>
        <div class="dCell" :class="logItem.index === selectedIncomingMsgItem.index && logDetailsPanel ? 'active' : ''">
            <strong>{{logItem.ResourcePath}}</strong>
        </div>
        <div class="dCell" :class="logItem.index === selectedIncomingMsgItem.index && logDetailsPanel ? 'active' : ''">
            <strong>{{logItem.ReqMethod}}</strong>
        </div>
        <div class="dCell" :class="logItem.index === selectedIncomingMsgItem.index && logDetailsPanel ? 'active' : ''">
                <span :class="[getResponseText(logItem.ResStatusCode).className]">{{logItem.ResStatusCode}} <span style="font-size: 12px; color: #ffffff;">{{ getResponseText(logItem.ResStatusCode).responseText }}</span></span>
        </div>
        <div class="dCell" :class="logItem.index === selectedIncomingMsgItem.index && logDetailsPanel ? 'active' : ''">
            <strong>
            {{formattedDate(logItem.CreatedDate)}}
            </strong>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
export default {
    name: 'incomingMessagesItem',
    props: ['logItem', 'selectedIncomingMsgItem', 'logDetailsPanel', 'showLogDetailsPanel'],
    data() {
        return {
            responseTextsList : [{responseText: 'OK', responseCode: 200, className: 'response-ok'}, {responseText: 'ERR', responseCode: 500, className: 'server-error'}, {responseText: 'ERR', responseCode: 400, className: 'client-error'}]
        }
    },
    methods: {
      formattedDate(dateString) {
        return moment.utc(dateString).format('DD MMM YYYY hh:mm:ss A')
      },
      getResponseText(code) {
        return this.responseTextsList.filter(eachItem => eachItem.responseCode == code)[0]
      }
    },

}
</script>

<style scoped>
.ApiCardHeightAdjustment{
    height: unset;
    width: unset;
    border: none;
}
.integrationLogoAlignment{
    background-position: left !important;
    margin: 2px unset unset 0px !important;
    height: 20px !important;
    background-size: contain !important;
    /* margin-left: 0px !important; */
}
.active {
    background: #f0f3fb !important;
}
</style>